import { Record, List } from 'immutable';

export const DEFAULT_ARCHIVE_CATEGORY_NAME = 'Archived';
export const DEFAULT_CUSTOM_CATEGORY_NAME = 'Uncategorized';
export const DEFAULT_CUSTOM_CATEGORY_ID = 19;

const defaultValues = {
  id: null,
  menuId: null,
  categoryName: '',
  description: '',
  syscoCategoryId: null,
  brandId: null,
  ordinal: 0,
};

export default class MenuItemCustomCategory extends Record(defaultValues, MenuItemCustomCategory) {
  constructor(values) {
    super({
      ...values,
    });
  }

  static getNextOrdinal(categories) {
    const unarchivedCategories = categories.filter((category) => {
      return category.get('categoryName') !== DEFAULT_ARCHIVE_CATEGORY_NAME;
    });
    const items = this.sortCategoriesByOrdinal(unarchivedCategories);
    const item = items.last();
    if (item) {
      return item.get('ordinal') + 1;
    }
    return 0;
  }

  static getOriginalOrdinal(categories) {
    const items = this.sortCategoriesByOrdinal(categories);
    const item = items.first();
    if (item) {
      return item.get('ordinal');
    }
    return 0;
  }

  static sortCategoriesByOrdinal(categories) {
    return categories.sort((itemOne, itemTwo) => {
      if (itemOne.get('ordinal') < itemTwo.get('ordinal')) return -1;
      if (itemOne.get('ordinal') > itemTwo.get('ordinal')) return 1;
      return 0;
    });
  }

  static getCategoryById(categories, id) {
    return categories.find((item) => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static getCategoryIndexById(categories, id) {
    return categories.findIndex(item => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static deleteCategoryByIndex(categories, index) {
    return categories.delete(index);
  }

  static insertCategoryByIndex(categories, index, category) {
    return categories.insert(index, category);
  }

  static formatCategoriesForOrdinalUpdate(categories) {
    const categoryData = {
      ids: [],
    };
    categories.forEach((item) => {
      categoryData.ids.push(item.get('id'));
    });
    return categoryData;
  }

  static updateCategoryOrdinalsFromIndex(categories) {
    return categories.map((item, index) => {
      if(item.get('categoryName') !== DEFAULT_ARCHIVE_CATEGORY_NAME) {
        return item.set('ordinal', index);
      }
      //Don't update "Archived" Category ordinal, default value == 9999
      return item;
    });
  }

  static getCategoryByMenuIdCateId(categories, menuId, categoryId) {
    return categories.find((item) => {
      return item.get('menuId') === menuId && item.get('id') === categoryId ? item : undefined;
    });
  }

  static removeArchivedCategory(categories) {
    return categories.filter((item) => {
      return item.get('categoryName') !== DEFAULT_ARCHIVE_CATEGORY_NAME;
    });
  }

  static getArchivedCategory(categories) {
    return categories.filter((item) => {
      return item.get('categoryName') === DEFAULT_ARCHIVE_CATEGORY_NAME;
    });
  }
}

export const MenuItemCustomCategories = (data) => {
  let menuItemCustomCategories = new List();
  if(data) {
    data.forEach((value) => {
      const { category } = value;
      menuItemCustomCategories = menuItemCustomCategories.push(new MenuItemCustomCategory(category || value));
    });
  }
  return menuItemCustomCategories;
}
